import {LoDashStatic} from "lodash";
const _ = <LoDashStatic> require('lodash');
require('./campaignDialog.less');

class CampaignsDialogController {
    activeCampaignForEdit;
    activeCampaign;

    constructor(private toastService, private Campaigns, private $filter, private $mdDialog){
    }

    $onInit() {
        if(this.activeCampaignForEdit){
            this.activeCampaign = _.pick(this.activeCampaignForEdit, ['sortNo', 'description', 'code', 'status']);
            this.activeCampaign.active = this.activeCampaign.status === 'ACTIVE';
        }
    }

    saveCampaign () {
        var campaign = {status: this.activeCampaign.active ? 'ACTIVE' : 'INACTIVE', sortNo: this.activeCampaign.sortNo, description: this.activeCampaign.description, code: this.activeCampaign.code};
        (this.activeCampaignForEdit ? this.Campaigns.updateCampaign({val: this.activeCampaignForEdit.id}, campaign) : this.Campaigns.postCampaigns(campaign)).$promise.then(
            () => {
                this.$mdDialog.hide("success");
            }, (error) => {
                this.toastService.parseError(error);
            }
        );
    };

    hide () {
        this.$mdDialog.hide();
    };
    cancel () {
        this.$mdDialog.cancel();
    };
}

class CampaignsDialogOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcCampaignsDialogController";
    public template: any = require('./campaignDialog.html');
    bindings: any = {
        activeCampaignForEdit:'='
    };
}

rkcApp.controller("rkcCampaignsDialogController", ['toastService', 'Campaigns', '$filter', '$mdDialog', function( toastService, Campaigns, $filter, $mdDialog){
    return new CampaignsDialogController(toastService, Campaigns, $filter, $mdDialog);
}])
    .component("campaignsDialog", new CampaignsDialogOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/campaigns/campaignDialog/campaignDialog.ts
 **/